/* English content variant. Structure MUST mirror portfolio.zh.js */

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {animated: true};

const greeting = {
  username: "Jindong Fu",
  title: "Hi, I'm Jindong Fu",
  subTitle: emoji(
    "🤖 AI Native Practitioner · 📱 Mobile Engineer · 🎨 Graphics — Software Engineer @ Microsoft. Embracing AI Native, pushing the boundaries of what AI can do, and turning large models into deliverable capabilities."
  ),
  resumeLink: "",
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/SymbolStar",
  linkedin: "",
  gmail: "891694368@qq.com",
  display: true
};

const skillsSection = {
  title: "What I do",
  subTitle:
    "AI AGENT TINKERER · MOBILE ENGINEER · GRAPHICS — CRAFTING NATIVE MOBILE EXPERIENCES AND EXPLORING THE INTERSECTION OF GRAPHICS, AI AGENTS, AND DEVELOPER TOOLING.",
  skills: [
    emoji(
      "⚡ Build tools and products around the AI Agent ecosystem — multi-agent coordination, agent task orchestration, agent-friendly data & signal services"
    ),
    emoji(
      "⚡ Foundational quality for large-scale iOS apps — crash / hang / storage / sign-in quality, serving millions of Copilot users"
    ),
    emoji(
      "⚡ iOS 3D rendering & Metal — real-time voice interaction with virtual avatar (Copilot Lumi Model)"
    ),
    emoji(
      "⚡ Smart hardware & embedded — Android smart hardware, children's robotics (Arduino), shared fitness pod device control"
    )
  ],
  softwareSkills: [
    {skillName: "swift", fontAwesomeClassname: "fab fa-swift"},
    {skillName: "apple", fontAwesomeClassname: "fab fa-apple"},
    {skillName: "android", fontAwesomeClassname: "fab fa-android"},
    {skillName: "java", fontAwesomeClassname: "fab fa-java"},
    {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
    {skillName: "TypeScript", fontAwesomeClassname: "fab fa-js-square"},
    {skillName: "reactjs", fontAwesomeClassname: "fab fa-react"},
    {skillName: "nodejs", fontAwesomeClassname: "fab fa-node"},
    {skillName: "python", fontAwesomeClassname: "fab fa-python"},
    {skillName: "html-5", fontAwesomeClassname: "fab fa-html5"},
    {skillName: "css3", fontAwesomeClassname: "fab fa-css3-alt"},
    {skillName: "git", fontAwesomeClassname: "fab fa-git-alt"},
    {skillName: "github", fontAwesomeClassname: "fab fa-github"},
    {skillName: "docker", fontAwesomeClassname: "fab fa-docker"},
    {skillName: "database", fontAwesomeClassname: "fas fa-database"},
    {skillName: "microchip", fontAwesomeClassname: "fas fa-microchip"},
    {skillName: "robot", fontAwesomeClassname: "fas fa-robot"}
  ],
  display: true
};

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Jinling Institute of Technology",
      logo: require("./assets/images/jitLogo.png"),
      subHeader: "B.Eng. · Electrical Engineering & Automation",
      duration: "金陵科技学院",
      desc: "",
      descBullets: []
    }
  ]
};

const techStack = {viewSkillBars: false, experience: [], displayCodersrank: false};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Software Engineer",
      company: "Microsoft",
      companylogo: require("./assets/images/microsoftLogo.png"),
      date: "Feb 2021 – Present",
      desc:
        "Bing / Copilot Mobile — journey from zero to millions of users, from foundational quality to AI interaction experience.",
      descBullets: [
        "🤖 Current: Office Copilot Agentic Harness — Copilot agent runtime framework for Office scenarios",
        "🎨 Copilot iOS · 3D-rendered Lumi Model — real-time voice interaction with virtual avatar to improve voice experience",
        "🛡️ Core member of Bing / Copilot App Foundation — crash rate / App hang rate / storage / sign-in quality"
      ]
    },
    {
      role: "Co-founder / Android & Hardware Lead",
      company: "Yepao Info Tech",
      companylogo: require("./assets/images/yepaoLogo.png"),
      date: "Startup — Shared Fitness Pod",
      desc:
        "Startup: shared fitness pod. Led Android app development (user + admin) and pod hardware control — locks, lighting, sensors, payment integration. From zero to operational site."
    },
    {
      role: "Mobile & Embedded Developer",
      company: "Suzhou Yunshijie Network Tech",
      companylogo: require("./assets/images/yunshijieLogo.png"),
      date: "Children's Robotics",
      desc:
        "Integrated hardware+software children's education robot: Android app (education / interaction / content delivery) + Arduino hardware layer (sensors, motors, interaction logic)."
    }
  ]
};

const openSource = {showGithubProfile: "true", display: true};

const bigProjects = {
  title: "Open Source Projects",
  subtitle:
    "SELECTED FROM github.com/SymbolStar (54 REPOS) · AI AGENT ECOSYSTEM · REAL DOWNLOAD STATS",
  projects: [
    {
      projectName: "✉️ gmail-mcp",
      projectDesc:
        "Gmail MCP (Model Context Protocol) server — expose Gmail to AI agents as a first-class tool.\n\n📥 npm: 1.4k downloads/month · 6.2k downloads/year",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/gmail-mcp"},
        {name: "npm", url: "https://www.npmjs.com/package/gmail-mcp"}
      ]
    },
    {
      projectName: "🔨 OpenForge",
      projectDesc:
        "Multi-agent task tracker for OpenClaw. Threads are tasks; @ assigns the next agent. Slack-style three-pane UI, JSONL event log, zero dependencies.\n\n⭐ 3 stars",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/OpenForge"}
      ]
    },
    {
      projectName: "🐦 magpie",
      projectDesc:
        "Lightweight A-share monitoring daemon — watchlist / price & fund-flow alerts / agent-friendly HTTP API. Reports good news and bad — like a magpie.\n\n📥 npm: 235 downloads/year · ⭐ 3 stars",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/magpie"},
        {name: "npm", url: "https://www.npmjs.com/package/magpie"}
      ]
    },
    {
      projectName: "🛡️ shipcheck",
      projectDesc:
        "Best-effort pre-publish PII and secret check for npm packages, OpenClaw skills, and local repos. Ship safer.\n\n📥 npm: 275 downloads/year",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/shipcheck"},
        {name: "npm", url: "https://www.npmjs.com/package/shipcheck"}
      ]
    },
    {
      projectName: "🔔 echo-cue",
      projectDesc:
        "Short Web-Audio cue when an OpenClaw Control UI assistant reply finishes. Floating picker widget + 11 chime presets.\n\n📈 Published on ClawHub · ⭐ 1 star",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/echoCue"},
        {name: "ClawHub", url: "https://clawhub.ai/skill/echo-cue"}
      ]
    },
    {
      projectName: "🦞 OpenClaw (Contributor)",
      projectDesc:
        "Personal AI assistant, any OS / any platform. Contributor to the core open-source project.\n\n🔀 4 merged PRs",
      footerLink: [
        {name: "GitHub", url: "https://github.com/openclaw/openclaw"}
      ]
    }
  ],
  display: true
};

const achievementSection = {title: emoji("Achievements 🏆"), subtitle: "", achievementsCards: [], display: false};
const blogSection = {title: "Blogs", subtitle: "", displayMediumBlogs: "false", blogs: [], display: false};
const talkSection = {title: "TALKS", subtitle: "", talks: [], display: false};
const podcastSection = {title: emoji("Podcast 🎙️"), subtitle: "", podcast: [], display: false};

const resumeSection = {title: "Resume", subtitle: "Feel free to download my resume", display: false};

const contactInfo = {
  title: emoji("Get in Touch ☎️"),
  subtitle:
    "Wanna talk projects, or just say hi? Ping me on GitHub or drop an email. For the latest AI updates, follow our Agent team WeChat Official Account 《小符在干嘛》. Also into 3D printing? Let\u2019s geek out together.",
  number: "",
  email_address: "891694368@qq.com",
  wechat_official: "小符在干嘛"
};

const twitterDetails = {userName: "", display: false};
const isHireable = false;

export {
  illustration, greeting, socialMediaLinks, splashScreen, skillsSection,
  educationInfo, techStack, workExperiences, openSource, bigProjects,
  achievementSection, blogSection, talkSection, podcastSection,
  contactInfo, twitterDetails, isHireable, resumeSection
};
